module.exports = __webpack_public_path__ + "assets/img/mask-life.57c341ca.png";